import React from "react";
import { Layout, Tabs } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { TabsProps } from "antd/lib";

const { Content } = Layout;

export interface ReleasePageWrapperProps {
  children?: React.ReactNode;
}

export const ReleasePageWrapper = (props: ReleasePageWrapperProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const items: TabsProps["items"] = [
    {
      key: "sdk",
      label: "SDK Releases",
    },
    {
      key: "adapter",
      label: "Adapter Releases",
    },
    {
      key: "plugin",
      label: "Plugins Releases",
    },
  ];

  const key = location.pathname.split("/")[2];

  const onChange = (key: string) => {
    navigate("/wizard/" + key, { replace: true });
  };

  return (
    <Layout>
      <Content>
        <Tabs activeKey={key} items={items} onChange={onChange} size="large" />
        {props.children}
      </Content>
    </Layout>
  );
};
